import { render, staticRenderFns } from "./GTemplateCard_old.vue?vue&type=template&id=648d1a38&scoped=true&"
import script from "./GTemplateCard_old.vue?vue&type=script&lang=ts&"
export * from "./GTemplateCard_old.vue?vue&type=script&lang=ts&"
import style0 from "./GTemplateCard_old.vue?vue&type=style&index=0&id=648d1a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d1a38",
  null
  
)

export default component.exports